import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import store from '../store'
import api from '@/api'
import 'nprogress/nprogress.css'


Vue.use(VueRouter)

const Login = () => import('@/views/Login.vue')
const Layout = () => import('@/views/Home.vue')
const PageNotFound = () => import('@/views/PageNotFound.vue')

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '',
    name: 'HomePage',
    component: Layout,
    children: []
  },
  {
    path: "*",
    component: PageNotFound
  },
];


const createRouter = () => new VueRouter({
  // base: process.env.NODE_ENV === 'production' ? '/userindex/' : './',
  routes,
  mode: 'history',
})
const router = createRouter()

router.resetRouter = function () {
  router.matcher = createRouter().matcher;
}

// 挂载路由导航守卫
router.beforeEach(async (to, from, next) => {
  if (to.path === "/command"&&to.query?.username && to.query?.password) {
    store.dispatch("login", {
      username:to.query?.username,
      password:to.query?.password,
    });
    setTimeout(() => {
      next({ path: "/command" })
    }, 1500);
  }else{
    if (to.path === '/login') return next()
    let tokeSta = window.sessionStorage.getItem('token')
    if (!tokeSta && to.path !== '/login') return next('/login')

    store.commit('SET_LOADING', false)
    const menuTree = JSON.parse(window.sessionStorage.getItem('routerList'))
    if (!store.state.user.asyncRoutestMark) {
      if (menuTree && menuTree.length && to.name !== 'login') {
        store.dispatch("addRouter", menuTree);
        next({ path: to.fullPath })
        replace: true
      }
      else {
        next('/login')
        // store.dispatch('getUserInfo')
      }
    } else {
      if (to.matched.length === 0) {
        from.name ? next({ name: from.name }) : next('/login')
      } else {
        next()
      }
    }
  }
})
// console.log('路由', router.getRoutes())

router.afterEach((to, from) => {
  store.commit("SET_NowRouter", to.path);
  store.dispatch("handleTabs", to);
})


NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

// 当路由进入前
router.beforeEach((to, from, next) => {
  // 每次切换页面时，调用进度条
  NProgress.start()
  next()
})
// 当路由进入后：关闭进度条
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})



export default router